import { z } from 'zod';
import { cleanIdPattern } from './clean-id.ts';

export const idSchema = z.string().regex(cleanIdPattern);
export const localeSchema = z
  .string()
  .min(2)
  .max(35)
  .refine((value) => {
    try {
      return Intl.getCanonicalLocales(value)[0] === value;
    } catch {
      return false;
    }
  }, 'Use a canonical language tag, such as en, es, or pt-BR.');
export const imageSourceSchema = z.discriminatedUnion('kind', [
  z.object({ kind: z.literal('Asset'), assetId: idSchema }).strict(),
  z.object({ kind: z.literal('Url'), url: z.url() }).strict(),
]);
export const siteImageSchema = z.union([imageSourceSchema, z.strictObject({})]);
export function siteImageSource(
  image: z.infer<typeof siteImageSchema>,
): z.infer<typeof imageSourceSchema> | undefined {
  if (!('kind' in image)) return undefined;
  if (image.kind === 'Asset') return { kind: 'Asset', assetId: image.assetId };
  return { kind: 'Url', url: image.url };
}
export const dateOrTimeSchema = z
  .string()
  .refine(
    (value) =>
      z.iso.date().safeParse(value).success ||
      z.iso
        .datetime({ offset: true, local: true })
        .safeParse(value.replace(/T(\d{2}:\d{2})(Z|[+-]\d{2}:\d{2})$/, 'T$1:00$2')).success,
    'Use an ISO date or date/time, including a timezone when known.',
  )
  .meta({ 'x-date-or-time': true });
